import { render, staticRenderFns } from "./SelectionAlertInfo.vue?vue&type=template&id=321cd084&scoped=true&"
import script from "./SelectionAlertInfo.vue?vue&type=script&lang=js&"
export * from "./SelectionAlertInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321cd084",
  null
  
)

export default component.exports